"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var __1 = require("../");
var Model_1 = require("../Model");
var Recipient = /** @class */ (function (_super) {
    __extends(Recipient, _super);
    function Recipient(id, name, emailAddress, phoneNumber, locationId) {
        var _this = _super.call(this, id) || this;
        _this.fetchLocation = function () { return __awaiter(_this, void 0, void 0, function () {
            var locationId, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        locationId = this.getLocationId;
                        if (!locationId) {
                            throw new Error("Location ID not found on Recipient");
                        }
                        _a = this;
                        return [4 /*yield*/, __1.Location.fetch(locationId)];
                    case 1:
                        _a.setLocation = _b.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.save = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Recipient.makeRequest("/delivery/private/recipient/" + this.getId, Model_1.METHOD.PUT, {
                            emailAddress: this.getEmailAddress,
                            locationId: this.getLocationId,
                            name: this.getName,
                            phoneNumber: this.getPhoneNumber,
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this];
                }
            });
        }); };
        _this.setName = name;
        _this.setEmailAddress = emailAddress;
        _this.setPhoneNumber = phoneNumber;
        _this.setLocationId = locationId;
        return _this;
    }
    Object.defineProperty(Recipient.prototype, "getName", {
        /**
         * GETTERS
         */
        get: function () {
            return this.name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Recipient.prototype, "getEmailAddress", {
        get: function () {
            return this.emailAddress;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Recipient.prototype, "getPhoneNumber", {
        get: function () {
            return this.phoneNumber;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Recipient.prototype, "getLocationId", {
        get: function () {
            return this.locationId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Recipient.prototype, "getLocation", {
        get: function () {
            var _this = this;
            if (!this.location) {
                return this.fetchLocation().then(function () { return _this.location; });
            }
            return this.location;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Recipient.prototype, "setName", {
        /**
         * SETTERS
         */
        set: function (name) {
            this.name = name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Recipient.prototype, "setEmailAddress", {
        set: function (emailAddress) {
            this.emailAddress = emailAddress;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Recipient.prototype, "setPhoneNumber", {
        set: function (phoneNumber) {
            this.phoneNumber = phoneNumber;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Recipient.prototype, "setLocationId", {
        set: function (locationId) {
            this.locationId = locationId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Recipient.prototype, "setLocation", {
        set: function (location) {
            this.location = location;
        },
        enumerable: true,
        configurable: true
    });
    Recipient.fetch = function (recipientId) { return __awaiter(_this, void 0, void 0, function () {
        var recipient;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Recipient.makeRequest("/delivery/private/stop/" + recipientId, Model_1.METHOD.GET)];
                case 1:
                    recipient = (_a.sent()).result;
                    return [2 /*return*/, new Recipient(recipient.id, recipient.name, recipient.emailAddress, recipient.phoneNumber, recipient.locationId)];
            }
        });
    }); };
    return Recipient;
}(Model_1.Model));
exports.Recipient = Recipient;
